"use strict";

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("damages").controller("DamageCtrl", DamageCtrl);

  function DamageCtrl($rootScope, $scope, $controller, $timeout, FormlyService, CustomListsService, GroupsService, UsersService, VehiclesService, CustomersService, DamagesService, LalsService, LalCostsService, InsurerContractsService, params) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "DamageCtrl";
    vm.withExternalVehicle = false;

    var accidentValues = ["circulation", "maneuver"];
    var glassValues = ["glass"];
    var horsAccidentValues = ["parking", "theft", "disaster", "fire", "handling", "repair", "building"];
    var explicitValues = [].concat(accidentValues, glassValues, horsAccidentValues);

    vm.refreshDrivers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return UsersService.remoteSelectArray(vm.positions.map(function (position) {
                return position.name;
              }));

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.refreshVehicles = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return VehiclesService.remoteSelectArray();

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    vm.refreshManagers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return UsersService.remoteSelectArray(vm.positions.map(function (position) {
                if (position.value != "Conducteur") {
                  return position.value;
                }
              }));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    vm.switchTab = function (tab) {
      vm.currentTab = tab.name;
    };

    vm.oldSwitchTab = function (group, tab) {
      group.currentTab = tab.name;
    };

    vm.openRepairers = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var value, select, emptyOption, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _repairer, option, label, div, repairerName, repairer;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              value = null;
              select = document.createElement("select");

              select.className = "form-control";

              emptyOption = document.createElement("option");

              emptyOption.innerHTML = "";
              emptyOption.value = "";
              select.appendChild(emptyOption);
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context4.prev = 10;
              for (_iterator = vm.model.repairers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _repairer = _step.value;
                option = document.createElement("option");

                option.innerHTML = _repairer.name + " - " + _repairer.address;
                option.value = _repairer.name;
                select.appendChild(option);
              }

              _context4.next = 18;
              break;

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context4.t0;

            case 18:
              _context4.prev = 18;
              _context4.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 21:
              _context4.prev = 21;

              if (!_didIteratorError) {
                _context4.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context4.finish(21);

            case 25:
              return _context4.finish(18);

            case 26:
              select.onchange = function selectChanged(e) {
                value = e.target.value;
              };

              label = document.createElement("label");

              label.innerHTML = "Réparateur :";

              div = document.createElement("div");

              div.appendChild(label);
              div.appendChild(select);

              _context4.next = 34;
              return swal({
                title: "Liste de vos réparateurs",
                content: {
                  element: div
                },
                icon: "warning",
                dangerMode: true,
                buttons: ["Annuler", "Valider"]
              });

            case 34:
              repairerName = _context4.sent;


              if (repairerName && value) {
                console.log("repairerName=", value);
                repairer = vm.model.repairers.find(function (r) {
                  return r.name === value;
                });

                vm.model.repairerInfo = repairer.name;
                vm.model.repairerAddress = repairer.address;

                // re-render the form
                $timeout(function () {
                  $scope.$apply();
                });
              } else if (repairerName && !value) {
                Notiflix.Notify.warning("Aucun réparateur sélectionné");
              }

            case 36:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this, [[10, 14, 18, 26], [19,, 21, 25]]);
    }));

    vm.calculateCost = function () {
      vm.model.newCostInsurer = 0;
      if (vm.lal && (vm.lal.costTotal || vm.lal.costTotal === 0)) {
        vm.model.newCostInsurer += Math.round(vm.lal.costTotal * 100) / 100;
      } else {
        if (vm.model.costProvision) {
          vm.model.newCostInsurer += vm.model.costProvision;
        }
      }

      vm.model.newCostCompagny = 0;
      vm.model.withCostDeductibleFromLal = false;
      // Ici la franchise LAL est toujours mise par défaut à 0 dans l'import LAL
      if (vm.lal && vm.lal.costDeductible) {
        vm.model.newCostCompagny += vm.lal.costDeductible;
        vm.model.lalCostDeductible = vm.lal.costDeductible;
        vm.model.withCostDeductibleFromLal = true;
      } else if (vm.model.costDeductible) {
        vm.model.newCostCompagny += vm.model.costDeductible;
      }
      if (vm.model.costThirdParty) {
        vm.model.newCostCompagny += vm.model.costThirdParty;
      }
      if (vm.model.costInternal) {
        vm.model.newCostCompagny += vm.model.costInternal;
      }
      if (vm.model.refundThirdParty) {
        vm.model.newCostCompagny -= vm.model.refundThirdParty;
      }

      vm.model.newCostTotal = vm.model.newCostCompagny + vm.model.newCostInsurer;

      vm.model.newCostTotal = Math.round(vm.model.newCostTotal * 100) / 100;
      vm.model.newCostCompagny = Math.round(vm.model.newCostCompagny * 100) / 100;
      vm.model.newCostInsurer = Math.round(vm.model.newCostInsurer * 100) / 100;
      LalCostsService.detachSharedCost(vm.model, vm.lal, true);
      vm.sharedLalCost = vm.model.sharedLalCost;
    };

    vm.createFields = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      var user, vehicle, defaultInsurerContract, insurerContract, isAdmin, isSuper, displaySendBt, writeResource, firstLine, driverMalusAmountList, amounts, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, amount, customClassificationList, items, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item, values, typeExternalCompanySelectArray, vehiclesList, driversList, groupsList, managersList, pourcentageDamageList, typeDamageStatusList, typeOfAccidentList, typeOfInjuryList, severityDamageList, vehicleTypeList, engineTypeList, lal, insurerCostFields;

      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return UsersService.findById({
                _id: $rootScope.$user._id.replace("$", "")
              });

            case 2:
              user = _context7.sent;

              vm.model.repairers = user.repairers ? user.repairers : [];

              _context7.next = 6;
              return localforage.getItem("oneAtATime");

            case 6:
              vm.oneAtATime = _context7.sent;


              console.log("vm.model=", vm.model);

              _context7.next = 10;
              return CustomersService.findById({
                _id: $rootScope.$selectedCustomerId.replace("$", ""),
                filter: {
                  fields: {
                    name: true,
                    refDamageNotEditable: true,
                    malusAmountList: true,
                    customClassification: true,
                    visibleDamageTypes: true,
                    withExternalVehicle: true,
                    assignGroupAfterDamageCreation: true,
                    defaultInsurerContract: true,
                    decosiRepairer: true,
                    severityDamageIsMandatory: true
                  }
                }
              });

            case 10:
              vm.customer = _context7.sent;

              vm.withExternalVehicle = vm.customer && vm.customer.withExternalVehicle === true;

              vm.model.isRestricted = true;

              if (!vm.model.vehicleId) {
                _context7.next = 32;
                break;
              }

              _context7.next = 16;
              return VehiclesService.getById(vm.model.vehicleId);

            case 16:
              vehicle = _context7.sent;

              if (!(!vehicle || !vehicle.insurerContract)) {
                _context7.next = 28;
                break;
              }

              if (!vm.customer.defaultInsurerContract) {
                _context7.next = 25;
                break;
              }

              _context7.next = 21;
              return InsurerContractsService.getById(vm.customer.defaultInsurerContract);

            case 21:
              defaultInsurerContract = _context7.sent;


              if (defaultInsurerContract && defaultInsurerContract.insurerEdiDocsAsLink === true) {
                vm.model.isRestricted = false;
              }
              _context7.next = 26;
              break;

            case 25:
              vm.model.isRestricted = true;

            case 26:
              _context7.next = 32;
              break;

            case 28:
              _context7.next = 30;
              return InsurerContractsService.getById(vehicle.insurerContract);

            case 30:
              insurerContract = _context7.sent;

              if (insurerContract && insurerContract.insurerEdiDocsAsLink === true) {
                vm.model.isRestricted = false;
              } else {
                vm.model.isRestricted = true;
              }

            case 32:

              vm.previousName = vm.model.name;
              vm.previousStatus = vm.model.typeDamageStatus;

              console.log("customer=", vm.customer);

              isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;
              isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;
              displaySendBt = isAdmin || isSuper || $rootScope.$user.rights && $rootScope.$user.rights.damage && $rootScope.$user.rights.damage.send && $rootScope.$user.rights.damage.send === true;
              writeResource = isAdmin || isSuper || $rootScope.$user.rights && $rootScope.$user.rights.resource && $rootScope.$user.rights.resource.write && $rootScope.$user.rights.resource.write === true;
              firstLine = [];


              vm.model.insurerRefInsurer = vm.model.insurer ? vm.model.insurer.refInsurer : "";

              if (vm.customer.refDamageNotEditable == true) {
                firstLine.push({
                  template: "<div class=\"col-xs-12\"><div class=\"form-group\"><label>R\xE9f\xE9rence du dossier</label><br><input value=\"" + (vm.model.name || "La référence sera crée automatiquement") + "\" class=\"form-control\" disabled/></div></div>"
                });
              } else {
                firstLine.push(FormlyService.text("name", "Référence du dossier", false, {
                  className: "col-xs-12"
                }));
              }

              if (displaySendBt) firstLine.push(FormlyService.boolOld("insurerNoReport", "Ne pas déclarer à l'assurance", false, {
                className: "col-xs-12 is-no-report-color"
              }));

              driverMalusAmountList = [{ name: " ", value: 0 }];

              if (!vm.customer.malusAmountList) {
                _context7.next = 66;
                break;
              }

              amounts = vm.customer.malusAmountList.split(";");

              if (!(amounts && amounts.length)) {
                _context7.next = 66;
                break;
              }

              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _iteratorError2 = undefined;
              _context7.prev = 50;

              for (_iterator2 = amounts[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                amount = _step2.value;

                driverMalusAmountList.push({
                  name: "- " + amount + " €",
                  value: Number(amount) * -1
                });
              }
              _context7.next = 58;
              break;

            case 54:
              _context7.prev = 54;
              _context7.t0 = _context7["catch"](50);
              _didIteratorError2 = true;
              _iteratorError2 = _context7.t0;

            case 58:
              _context7.prev = 58;
              _context7.prev = 59;

              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }

            case 61:
              _context7.prev = 61;

              if (!_didIteratorError2) {
                _context7.next = 64;
                break;
              }

              throw _iteratorError2;

            case 64:
              return _context7.finish(61);

            case 65:
              return _context7.finish(58);

            case 66:
              customClassificationList = [{ name: " ", value: "" }];

              if (!vm.customer.customClassification) {
                _context7.next = 89;
                break;
              }

              items = vm.customer.customClassification.split(";");

              if (!(items && items.length)) {
                _context7.next = 89;
                break;
              }

              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context7.prev = 73;

              for (_iterator3 = items[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                item = _step3.value;

                if (item && item.length) {
                  customClassificationList.push({
                    name: item,
                    value: item
                  });
                }
              }
              _context7.next = 81;
              break;

            case 77:
              _context7.prev = 77;
              _context7.t1 = _context7["catch"](73);
              _didIteratorError3 = true;
              _iteratorError3 = _context7.t1;

            case 81:
              _context7.prev = 81;
              _context7.prev = 82;

              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }

            case 84:
              _context7.prev = 84;

              if (!_didIteratorError3) {
                _context7.next = 87;
                break;
              }

              throw _iteratorError3;

            case 87:
              return _context7.finish(84);

            case 88:
              return _context7.finish(81);

            case 89:
              if (!vm.model.decosiInfo) {
                _context7.next = 97;
                break;
              }

              vm.reporterName = "code client/inconnu";

              if (!(vm.model.decosiInfo && vm.model.decosiInfo.reporter && vm.model.decosiInfo.reporter.id)) {
                _context7.next = 95;
                break;
              }

              _context7.next = 94;
              return UsersService.getNameById(vm.model.decosiInfo.reporter.id);

            case 94:
              vm.reporterName = _context7.sent;

            case 95:
              vm.creationDate = new Date(vm.model.creationDate).toLocaleString();

              if (vm.model.decosiInfo && vm.model.decosiInfo.manager && vm.model.decosiInfo.manager.text) {
                vm.managerName = vm.model.decosiInfo.manager.text;
              }

            case 97:
              if (!vm.model.creationUserId) {
                _context7.next = 101;
                break;
              }

              _context7.next = 100;
              return UsersService.getNameById(vm.model.creationUserId);

            case 100:
              vm.reporterName = _context7.sent;

            case 101:
              vm.creationDate = new Date(vm.model.creationDate).toLocaleString();

              _context7.next = 104;
              return UsersService.getPositionArray($rootScope.$selectedCustomerId);

            case 104:
              vm.positions = _context7.sent;
              _context7.next = 107;
              return Promise.all([CustomListsService.getSelectArray("typeExternalCompany"), //0
              VehiclesService.remoteSelectArray(), //1
              UsersService.remoteSelectArray(), //2
              GroupsService.getDamageSelectArray(), //3
              UsersService.remoteSelectArray(
              // 4
              vm.positions.map(function (position) {
                if (position.value != "Conducteur") {
                  return position.value;
                }
              })), CustomListsService.getSelectArray("pourcentageDamage"), //5
              CustomListsService.getSelectArray("typeDamageStatus"), //6
              CustomListsService.getSelectArray("typeOfAccidentV2"), //7
              CustomListsService.getSelectArray("typeOfInjury"), //8
              CustomListsService.getSelectArray("severityDamage"), // 9
              CustomListsService.getSelectArray("typeVehicleV2"), // 10
              CustomListsService.getSelectArray("typeVehicleEngineV2")] // 11
              );

            case 107:
              values = _context7.sent;


              $scope.$watch("vm.model.groupIdIsAutoFilled", function () {
                // set to true if driver is not selected at the beginning
                if (vm.customer.assignGroupAfterDamageCreation === "driver" && !vm.model.driverId) {
                  vm.model.groupIdIsAutoFilled = true;
                }
              });

              $scope.$watch("vm.model.vehicleId", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var vehicle, _defaultInsurerContract, _insurerContract;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return VehiclesService.getById(vm.model.vehicleId);

                      case 2:
                        vehicle = _context5.sent;

                        if (!(!vehicle || !vehicle.insurerContract)) {
                          _context5.next = 14;
                          break;
                        }

                        if (!vm.customer.defaultInsurerContract) {
                          _context5.next = 11;
                          break;
                        }

                        _context5.next = 7;
                        return InsurerContractsService.getById(vm.customer.defaultInsurerContract);

                      case 7:
                        _defaultInsurerContract = _context5.sent;


                        if (_defaultInsurerContract && _defaultInsurerContract.insurerEdiDocsAsLink === true) {
                          vm.model.isRestricted = false;
                        }
                        _context5.next = 12;
                        break;

                      case 11:
                        vm.model.isRestricted = true;

                      case 12:
                        _context5.next = 18;
                        break;

                      case 14:
                        _context5.next = 16;
                        return InsurerContractsService.getById(vehicle.insurerContract);

                      case 16:
                        _insurerContract = _context5.sent;


                        if (_insurerContract && _insurerContract.insurerEdiDocsAsLink === true) {
                          vm.model.isRestricted = false;
                        } else {
                          vm.model.isRestricted = true;
                        }

                      case 18:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, this);
              })));

              // Re-render the form when cost fields are updated
              $scope.$watchGroup(["vm.model.costProvision", "vm.model.costDeductible", "vm.model.costThirdParty", "vm.model.costInternal", "vm.model.refundThirdParty", "vm.model.insurerNoReport"], function () {
                vm.calculateCost();
              });

              $scope.$watchGroup(["vm.model.driverId", "vm.model.managerId"], function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref8) {
                  var _ref9 = _slicedToArray(_ref8, 2),
                      newDriverId = _ref9[0],
                      newManagerId = _ref9[1];

                  var driver, manager, isCreation;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.prev = 0;
                          driver = null;
                          manager = null;
                          isCreation = !vm.model._id;

                          if (!(isCreation && newDriverId && vm.customer.assignGroupAfterDamageCreation === "driver")) {
                            _context6.next = 8;
                            break;
                          }

                          _context6.next = 7;
                          return UsersService.getById(newDriverId.replace("$", ""));

                        case 7:
                          driver = _context6.sent;

                        case 8:
                          if (!(isCreation && newManagerId && vm.customer.assignGroupAfterDamageCreation === "manager")) {
                            _context6.next = 12;
                            break;
                          }

                          _context6.next = 11;
                          return UsersService.getById(newManagerId.replace("$", ""));

                        case 11:
                          manager = _context6.sent;

                        case 12:

                          if (isCreation) {
                            vm.model.groupIdIsAutoFilled = false;
                            if (vm.customer.assignGroupAfterDamageCreation === "driver" && driver && driver.groupsId && driver.groupsId.length > 0) {
                              vm.model.groupId = driver.groupsId[0];
                              vm.model.groupIdIsAutoFilled = true;
                            } else if (vm.customer.assignGroupAfterDamageCreation === "manager" && manager && manager.groupsId && manager.groupsId.length > 0) {
                              vm.model.groupId = manager.groupsId[0];
                            } else if (!vm.customer.assignGroupAfterDamageCreation && !vm.model.groupId) {
                              vm.model.groupId = null;
                            }
                          }
                          _context6.next = 18;
                          break;

                        case 15:
                          _context6.prev = 15;
                          _context6.t0 = _context6["catch"](0);

                          console.error("Erreur lors de la récupération des informations du collaborateur ou du manager:", _context6.t0);

                        case 18:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6, this, [[0, 15]]);
                }));

                return function (_x) {
                  return _ref7.apply(this, arguments);
                };
              }());

              typeExternalCompanySelectArray = values[0];
              vehiclesList = values[1];
              driversList = values[2];
              groupsList = values[3];
              managersList = values[4];
              pourcentageDamageList = values[5];
              typeDamageStatusList = values[6];
              typeOfAccidentList = values[7];
              typeOfInjuryList = values[8];
              severityDamageList = values[9];
              vehicleTypeList = values[10];
              engineTypeList = values[11];

              // Display "Pas d'élément sélectionnée" if -1

              if (vm.model.pourcentageDispute != 0 && vm.model.pourcentageDispute != 50 && vm.model.pourcentageDispute != 100) {
                vm.model.pourcentageDispute = "";
              }

              if (vm.model.insurer && vm.model.insurer.noReport === true) {
                vm.model.insurerNoReport = true;
              } else {
                vm.model.insurerNoReport = false;
              }

              lal = null;

              if (!(vm.model.lalIds && vm.model.lalIds.length > 0)) {
                _context7.next = 137;
                break;
              }

              _context7.prev = 128;
              _context7.next = 131;
              return LalsService.findById({
                _id: vm.model.lalIds[vm.model.lalIds.length - 1],
                filter: {
                  fields: {
                    pourcentageDispute: true,
                    statusInsurer: true,
                    costTotal: true,
                    costDeductible: true,
                    refInsurer: true,
                    damageIds: true,
                    _id: true,
                    dateDamage: true
                  }
                }
              });

            case 131:
              lal = _context7.sent;
              _context7.next = 137;
              break;

            case 134:
              _context7.prev = 134;
              _context7.t2 = _context7["catch"](128);

              console.log(_context7.t2);

            case 137:

              if (!lal) {
                lal = {
                  pourcentageDispute: "Inconnue",
                  statusInsurer: "Inconnu",
                  refInsurer: "Inconnue"
                };
              } else if (lal.costTotal) {
                lal.costTotal = Math.round(lal.costTotal * 100) / 100;
              }

              if (!lal.statusInsurer) {
                lal.statusInsurer = "Non précisé";
              }

              if (lal.pourcentageDispute != "Inconnue" && lal.pourcentageDispute != 0 && lal.pourcentageDispute != 50 && lal.pourcentageDispute != 100) {
                lal.pourcentageDispute = "Non précisé";
              } else if (lal.pourcentageDispute != "Inconnue") {
                lal.pourcentageDispute += " %";
              }

              if (!vm.model.driverId) {
                _context7.next = 146;
                break;
              }

              _context7.next = 143;
              return UsersService.getNameById(vm.model.driverId);

            case 143:
              _context7.t3 = _context7.sent;
              _context7.next = 147;
              break;

            case 146:
              _context7.t3 = null;

            case 147:
              vm.driverName = _context7.t3;

              if (!vm.model.vehicleId) {
                _context7.next = 154;
                break;
              }

              _context7.next = 151;
              return VehiclesService.getNameById(vm.model.vehicleId);

            case 151:
              _context7.t4 = _context7.sent;
              _context7.next = 155;
              break;

            case 154:
              _context7.t4 = null;

            case 155:
              vm.plateNumber = _context7.t4;

              if (!vm.model.typeOfAccident) {
                _context7.next = 162;
                break;
              }

              _context7.next = 159;
              return CustomListsService.getNameByValue("typeOfAccidentV2", vm.model.typeOfAccident);

            case 159:
              _context7.t5 = _context7.sent;
              _context7.next = 163;
              break;

            case 162:
              _context7.t5 = null;

            case 163:
              vm.typeOfAccidentName = _context7.t5;


              vm.displayTitle = vm.model._id ? "Sinistre n°" + vm.model.name + " du " + new Date(vm.model.dateDamage).toLocaleString().split(" ")[0] + " du collaborateur " + vm.driverName + (explicitValues.includes(vm.model.typeOfAccident) ? " avec le véhicule " + (vm.plateNumber ? vm.plateNumber : vm.model.externalVehicleName) : "") + (vm.reporterName ? " - Déclaré par " + vm.reporterName : "") + " le " + vm.creationDate : "Nouveau sinistre";

              vm.currentTab = "Généralités";

              vm.lal = lal;
              vm.calculateCost();

              insurerCostFields = lal.costTotal || lal.costTotal === 0 ? [FormlyService.currency("newCostInsurer", "Coût transmis par l'assureur à LVR", false, {
                className: "col-xs-12 col-sm-12 col-md-12"
              }, "Non modifiable", true)] : [FormlyService.currency("costProvision", "Estimation par le client", false, {
                className: "col-xs-12 col-sm-12 col-md-12"
              }, "Effacé dès que le coût est transmis par l'assureur")];


              vm.tabs = [{
                name: "Généralités",
                rows: [{
                  columns: [{
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: [{
                      mainTitle: "Suivi",
                      fields: [FormlyService.list("groupId", "Groupe associé", groupsList, vm.model._id ? false : true, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: "model.groupIdIsAutoFilled"
                      }), FormlyService.list("managerId", "Responsable du suivi de ce dossier", managersList, false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        templateOptions: {
                          createButton: writeResource,
                          editButton: writeResource,
                          refreshButton: true,
                          refresh: vm.refreshManagers
                        },
                        controller: ["$scope", function ($scope) {
                          $controller("SelectUserController", {
                            positions: vm.positions.map(function (position) {
                              if (position.value != "Conducteur") {
                                return position.value;
                              }
                            }),
                            $scope: $scope
                          });
                        }]
                      }), {
                        template: vm.managerName ? "<div class=\"col-xs-12\"><div class=\"form-group\"><label>Nom du manageur saisie par le d\xE9clarant</label><br/><input value=\"" + vm.managerName + "\" class=\"form-control\" disabled/></div>" : ""
                      }].concat(firstLine, [FormlyService.text("refInsurer", "Réf. provisoire assureur", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.text("insurerRefInsurer", "Réf. saisie par l'assureur/courtier", false, {
                        className: "col-xs-12 col-sm-6 col-md-6",
                        hideExpression: "!model.insurer || !model.insurer.refInsurer"
                      }), {
                        template: "<div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=\"form-group\"><label>R\xE9f. assureur</label><br/><input value=\"" + lal.refInsurer + "\" class=\"form-control\" disabled/></div></div>"
                      }, FormlyService.date("dateOpenDispute", "Date d'ouverture", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.date("dateCloseDispute", "Date de clôture", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.list("typeDamageStatus", "Statut du dossier", typeDamageStatusList, false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), {
                        template: "<div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=\"form-group\"><label>Statut assureur</label><br/><input value=\"" + lal.statusInsurer + "\" class=\"form-control\" disabled/></div></div>"
                      }, FormlyService.list("customClassification", "Classification interne", customClassificationList, false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })])
                    }, {
                      mainTitle: "Actions",
                      fields: [FormlyService.date("dateLastAction", "Date de la dernière action ?", false, {
                        className: "col-xs-6 col-sm-6"
                      }), FormlyService.text("contactLastAction", "Vers qui ?", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.text("lastAction", "Action menée ?", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.textArea("nextAction", "Actions à mener ?", "", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: [{
                      mainTitle: "Circonstances",
                      fields: [FormlyService.list("driverId", "Collaborateur sinistré", driversList, true, {
                        className: "col-xs-12",
                        templateOptions: {
                          createButton: writeResource,
                          editButton: writeResource,
                          refreshButton: true,
                          refresh: vm.refreshDrivers
                        },
                        controller: ["$scope", function ($scope) {
                          $controller("SelectUserController", {
                            positions: ["Conducteur"],
                            $scope: $scope
                          });
                        }]
                      }), FormlyService.bool("driverIsRelative", "La personne sinistrée est le/la conjoint(e), un enfant ou proche de ce collaborateur", false, {
                        className: "col-xs-12"
                      }), FormlyService.date("dateDamage", "Date de survenance", true, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.text("timeDamage", "Heure du sinistre (facultatif)", false, {
                        className: "col-xs-12 col-sm-6 col-md-6",
                        templateOptions: { placeholder: "HH:mm", maxlength: 5 }
                      }, "Laissez vide si l'heure est inconnue"), FormlyService.text("location", "Lieu de survenance", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.list("typeOfAccident", "Type de sinistre", typeOfAccidentList.filter(function (item) {
                        // Un type déjà sélectionné sur le sinistre reste toujours visible
                        if (vm.model.typeOfAccident === item.value) return true;
                        var visible = vm.customer.visibleDamageTypes;
                        if (visible && visible.indexOf(item.value) === -1) return false;
                        return true;
                      }), true, { className: "col-xs-12 col-sm-12 col-md-12" }), FormlyService.list("pourcentageDispute", "Resp. présumée", pourcentageDamageList, false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), {
                        template: "<div class=\"col-xs-12 col-sm-6 col-md-6\"><div class=\"form-group\"><label>Resp. assureur</label><br/><input value=\"" + lal.pourcentageDispute + "\" class=\"form-control\" disabled/></div></div>"
                      }, FormlyService.textArea("circumstance", vm.model._id ? "Circonstances du sinistre" : "Circonstances du sinistre (30 caractères minimum)", "", true, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.bool("statsExcluded", "Exclu des statistiques", false, { className: "col-xs-12", templateOptions: { disabled: !isSuper }, hideExpression: function hideExpression() {
                          return !isSuper;
                        } }), FormlyService.textArea("statsExclusionReason", "Motif d’exclusion des statistiques", "", false, { className: "col-xs-12", hideExpression: "!model.statsExcluded", expressionProperties: { "templateOptions.required": "model.statsExcluded", "templateOptions.disabled": function templateOptionsDisabled() {
                            return !isSuper;
                          } } }), FormlyService.bool("withInjury", "Blessé(s) même léger(s)", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.list("typeOfInjury", "Qui a été blessé ?", typeOfInjuryList, false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: "!model.withInjury"
                      }), FormlyService.bool("withThirdParty", "Un tiers est impliqué", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.text("thirdPartyDriverName", "Nom Prénom du tiers", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: "!model.withThirdParty"
                      }), FormlyService.text("thirdPartyCompagnyName", "Société du tiers", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: "!model.withThirdParty"
                      }), FormlyService.text("thirdPartyAssurerName", "Assureur du tiers", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: "!model.withThirdParty"
                      }), FormlyService.textArea("comment", "Commentaires", "", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: [{
                      mainTitle: "Véhicule",
                      fields: [FormlyService.list("vehicleId", "Véhicule interne", vehiclesList, explicitValues.includes(vm.model.typeOfAccident) ? true : false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: function hideExpression() {
                          return vm.withExternalVehicle && vm.model.externalVehicle === true;
                        },
                        templateOptions: {
                          createButton: writeResource,
                          editButton: writeResource,
                          refreshButton: true,
                          refresh: vm.refreshVehicles
                        },
                        controller: ["$scope", function ($scope) {
                          $controller("SelectVehicleController", {
                            $scope: $scope
                          });
                        }]
                      }), FormlyService.text("externalVehicleName", "Identifiant du véhicule externe (Immat, ...)", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: function hideExpression() {
                          return !vm.withExternalVehicle || !vm.model.externalVehicle;
                        }
                      }), FormlyService.bool("externalVehicle", "Le véhicule est externe à l'entreprise", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: function hideExpression() {
                          return !vm.withExternalVehicle;
                        }
                      }), FormlyService.text("externalVehicleCompany", "Société du véhicule externe", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: function hideExpression() {
                          return !vm.withExternalVehicle || !vm.model.externalVehicle;
                        }
                      }), FormlyService.list("externalVehicleCompanyType", "Type de société du véhicule externe", typeExternalCompanySelectArray, false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: function hideExpression() {
                          return !vm.withExternalVehicle || !vm.model.externalVehicle;
                        }
                      }), FormlyService.list("severityDamage", "Gravité des dommages du véhicule", severityDamageList, explicitValues.includes(vm.model.typeOfAccident) && (vm.customer.decosiRepairer === "mandatory" || vm.customer.severityDamageIsMandatory === true), { className: "col-xs-12 col-sm-12 col-md-12" }), FormlyService.list("vehicleType", "Type de véhicule", vehicleTypeList, explicitValues.includes(vm.model.typeOfAccident) ? true : false, { className: "col-xs-12 col-sm-12 col-md-12" }), FormlyService.list("engineType", "Type de moteur", engineTypeList, false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: function hideExpression() {
                          return ["VELO", "EDP", "REMSEULE"].includes(vm.model.vehicleType);
                        }
                      }), FormlyService.number("mileage", "Kilométrage relevé au moment du sinistre", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.bool("vehicleTowed", "Le véhicule a t-il été remorqué ?", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.text("trailerName", "N° Remorque", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.text("containerName", "N° Conteneur", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.bool("trailerDamaged", "Remorque abimée ?", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.bool("containerDamaged", "Conteneur abimé ?", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.text("tourNumber", "N° de la tournée/de l'OT", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      }), FormlyService.text("tourCustomer", "Client lié à la tournée/à l'OT", false, {
                        className: "col-xs-12 col-sm-6 col-md-6"
                      })]
                    }, {
                      mainTitle: "Réparateur",
                      fields: [FormlyService.button("Ouvrir la liste de mes réparateurs", vm.openRepairers, {
                        hideExpression: "!model.repairers || model.repairers.length === 0"
                      }), FormlyService.text("repairerInfo", "Nom du réparateur", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.textArea("repairerAddress", "Adresse du réparateur", "", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }]
                }]
              }, {
                name: "Documents",
                rows: [{
                  columns: [{
                    class: "col-xs-12 col-sm-12 col-md-12",
                    boxes: [{
                      mainTitle: "Documents à transmettre à l'assurance",
                      fields: [FormlyService.doc("docs", "", "damage", false, {
                        hideExpression: "model.isRestricted",
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }, "", false), FormlyService.doc("docs", "", "damage", false, {
                        hideExpression: "!model.isRestricted",
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }, "", true)]
                    }, {
                      mainTitle: "Autres documents (pour suivi du dossier en interne)",
                      fields: [FormlyService.doc("docsBilling", "", "cost", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }, "", false)]
                    }]
                  }]
                }]
              }, {
                name: "Coûts et chiffrages",
                rows: [{
                  columns: [{
                    class: "col-xs-12 col-sm-2 col-md-2",
                    boxes: []
                  }, {
                    class: "col-xs-12 col-sm-8 col-md-8",
                    boxes: [{
                      mainTitle: vm.sharedLalCost ? "Frais propres au sinistre (hors coût commun)" : "Coût total",
                      // color: "#2699ca",
                      fields: [FormlyService.currency("newCostTotal", "Coût total", false, {
                        className: "col-xs-12 col-sm-3 col-md-3"
                      }, "Calculé automatiquement", true), {
                        template: "<div class=\"col-xs-12 col-sm-1 col-md-1\" style=\"margin-top: 22px; text-align: center;\"><span style=\"font-size: 24px; font-weight: bold\">=</span></div>"
                      }, FormlyService.currency("newCostCompagny", "Coût à notre charge", false, {
                        className: "col-xs-12 col-sm-3 col-md-3 is-cost-company-color"
                      }, "Calculé automatiquement selon les coûts ci-dessous", true), {
                        template: "<div class=\"col-xs-12 col-sm-1 col-md-1\" style=\"margin-top: 22px; text-align: center;\"><span style=\"font-size: 24px; font-weight: bold\">+</span></div>"
                      }, FormlyService.currency("newCostInsurer", "Coût Assureur", false, {
                        className: "col-xs-12 col-sm-3 col-md-3 is-cost-insurer-color"
                      }, "Calculé automatiquement selon les coûts ci-dessous", true)]
                    }]
                  }]
                }, {
                  columns: [{
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: []
                  }, {
                    class: "col-xs-12 col-sm-3 col-md-3",
                    boxes: [{
                      mainTitle: "Coût à notre charge =",
                      color: "#F9A159",
                      fields: [FormlyService.currency("lalCostDeductible", "Franchise / Auto Assurance", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: "!model.withCostDeductibleFromLal"
                      }, "Franchise transmise par l'assureur à LVR", true), FormlyService.currency("costDeductible", "Franchise / Auto Assurance", false, {
                        className: "col-xs-12 col-sm-12 col-md-12",
                        hideExpression: "model.withCostDeductibleFromLal"
                      }), FormlyService.currency("costInternal", "+ Réparations véhicule flotte / Provision FRE", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }, "FRE = Frais de Remise en Etat"), FormlyService.currency("costThirdParty", "+ Indemnisation tiers", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.currency("refundThirdParty", "- Remboursement par le tiers", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-3 col-md-3",
                    boxes: [{
                      mainTitle: "Coût Assureur =",
                      color: "#97A164",
                      fields: insurerCostFields
                    }]
                  }]
                }, {
                  columns: [{
                    class: "col-xs-12 col-sm-2 col-md-2",
                    boxes: []
                  }, {
                    class: "col-xs-12 col-sm-2 col-md-2",
                    boxes: [{
                      mainTitle: "Estimation des réparations",
                      fields: [FormlyService.currency("estimateAmountHT", "Montant estimé des réparations (HT)", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.currency("estimateAmountNotRepairedHT", "Montant estimé des dommages non réparés (HT)", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-3 col-md-3",
                    boxes: [{
                      mainTitle: "Expertise / Chiffrage à distance",
                      fields: [FormlyService.date("dateReport", "Date de l'expertise", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.text("damageExpertName", "Nom/Société de l'expert", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.currency("damageExpertCostHT", "Montant de l'expertise (HT)", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-3 col-md-3",
                    boxes: [{
                      mainTitle: "Autre",
                      fields: [FormlyService.bool("aggreement", "Accord amiable ?", false, {
                        className: "col-xs-12 col-sm-12"
                      }), FormlyService.currency("costRelatedToDriver", "Montant retenu pour calcul prime collaborateur", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.list("malusDriverAmount", "Malus prime collaborateur", driverMalusAmountList, false, {
                        className: "col-xs-12"
                      }), FormlyService.textArea("costNotes", "Notes", "", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }]
                }]
              }, {
                name: "Devis et remboursements",
                rows: [{
                  columns: [{
                    class: "col-xs-12 col-sm-2 col-md-2",
                    boxes: [{
                      mainTitle: "Devis réparations véhicule",
                      fields: [FormlyService.currency("quoteVehicle", "Montant du devis", false, { className: "col-xs-12 col-sm-12 col-md-12" }), FormlyService.text("quoteVehicleCompany", "Société", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.text("quoteVehicleNote", "Notes", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-2 col-md-2",
                    boxes: [{
                      mainTitle: "Devis réparations remorque",
                      fields: [FormlyService.currency("quoteTrailer", "Montant du devis", false, { className: "col-xs-12 col-sm-12 col-md-12" }), FormlyService.text("quoteTrailerCompany", "Société", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.text("quoteTrailerNote", "Notes", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: [{
                      mainTitle: "Remboursement n°1",
                      fields: [FormlyService.currency("reInvoicingAmount1", "Montant", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.text("reInvoicingNumber1", "N° de facture", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.list("reInvoicingCompanyType1", "Type de Société", typeExternalCompanySelectArray, false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.text("reInvoicingCompany1", "Société", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.bool("reInvoicingAggreement1", "Accord ?", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.bool("reInvoicingPaid1", "Réglée ?", false, {
                        className: "col-xs-12 col-sm-6"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: [{
                      mainTitle: "Remboursement n°2",
                      fields: [FormlyService.currency("reInvoicingAmount2", "Montant", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.text("reInvoicingNumber2", "N° de facture", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.list("reInvoicingCompanyType2", "Type de Société", typeExternalCompanySelectArray, false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.text("reInvoicingCompany2", "Société", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.bool("reInvoicingAggreement2", "Accord ?", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.bool("reInvoicingPaid2", "Réglée ?", false, {
                        className: "col-xs-12 col-sm-6"
                      })]
                    }]
                  }]
                }, {
                  columns: [{
                    class: "col-xs-12 col-sm-2 col-md-2",
                    boxes: [{
                      mainTitle: "Devis réparations diverses",
                      fields: [FormlyService.currency("quoteOther", "Montant du devis", false, { className: "col-xs-12 col-sm-12 col-md-12" }), FormlyService.text("quoteOtherCompany", "Société", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.text("quoteOtherNote", "Notes", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-2 col-md-2",
                    boxes: [{
                      mainTitle: "Devis réparations du tiers",
                      fields: [FormlyService.currency("quoteThirdParty", "Montant du devis", false, { className: "col-xs-12 col-sm-12 col-md-12" }), FormlyService.text("quoteThirdPartyCompany", "Société", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      }), FormlyService.text("quoteThirdPartyNote", "Notes", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: [{
                      mainTitle: "Remboursement n°3",
                      fields: [FormlyService.currency("reInvoicingAmount3", "Montant", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.text("reInvoicingNumber3", "N° de facture", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.list("reInvoicingCompanyType3", "Type de Société", typeExternalCompanySelectArray, false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.text("reInvoicingCompany3", "Société", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.bool("reInvoicingAggreement3", "Accord ?", false, {
                        className: "col-xs-12 col-sm-6"
                      }), FormlyService.bool("reInvoicingPaid3", "Réglée ?", false, {
                        className: "col-xs-12 col-sm-6"
                      })]
                    }]
                  }, {
                    class: "col-xs-12 col-sm-4 col-md-4",
                    boxes: [{
                      mainTitle: "Notes remboursements",
                      fields: [FormlyService.textArea("reInvoicingNote", "Notes", "", false, {
                        className: "col-xs-12 col-sm-12 col-md-12"
                      })]
                    }]
                  }]
                }]
              }];

              $timeout(function () {}, 10);

            case 171:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this, [[50, 54, 58, 66], [59,, 61, 65], [73, 77, 81, 89], [82,, 84, 88], [128, 134]]);
    }));

    vm.check = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var save, useExternalVehicle, vehicleIdErrorMessage, value, responseToCheck, _responseToCheck;

      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (!(vm.model.timeDamage && !/^([01]\d|2[0-3]):[0-5]\d$/.test(vm.model.timeDamage))) {
                _context8.next = 4;
                break;
              }

              Notiflix.Notify.failure("Veuillez saisir une heure du sinistre valide au format HH:mm.");
              vm.currentTab = "Généralités";
              return _context8.abrupt("return");

            case 4:
              save = true;

              if (!(vm.model.statsExcluded && !(vm.model.statsExclusionReason || "").trim())) {
                _context8.next = 8;
                break;
              }

              Notiflix.Notify.failure("Le motif d’exclusion statistique est obligatoire.");
              return _context8.abrupt("return");

            case 8:

              if (!vm.model.circumstance && !vm.model._id) {
                // Only if creation
                Notiflix.Notify.failure("Vous n'avez pas décrit les circonstances");
                vm.currentTab = "Généralités";
                save = false;
              } else if ((!vm.model.circumstance || vm.model.circumstance.length < 30) && !vm.model._id) {
                // Only if creation
                Notiflix.Notify.failure("Veuillez faire une phrase d'au moins 30 caractères pour les circonstances");
                vm.currentTab = "Généralités";
                save = false;
              }

              if (!vm.model.typeOfAccident) {
                Notiflix.Notify.failure("Vous n'avez pas indiqué le type de sinistre");
                vm.currentTab = "Généralités";
                save = false;
              }

              if (!vm.model.dateDamage) {
                Notiflix.Notify.failure("Vous n'avez pas indiqué la date du sinistre");
                vm.currentTab = "Généralités";
                save = false;
              } else if (new Date(vm.model.dateDamage) > new Date() && !vm.model._id) {
                // Only if creation
                Notiflix.Notify.failure("La date du sinistre renseignée est dans le futur !");
                vm.currentTab = "Généralités";
                save = false;
              }

              useExternalVehicle = vm.withExternalVehicle && vm.model.externalVehicle === true;


              if (useExternalVehicle && !vm.model.externalVehicleName) {
                Notiflix.Notify.failure("Vous n'avez pas indiqué l'immatriculation du véhicule externe");
                vm.currentTab = "Généralités";
                save = false;
              }

              if (!useExternalVehicle && explicitValues.includes(vm.model.typeOfAccident)) {
                if (!vm.model.vehicleId || vm.model.vehicleId.length < 24) {
                  vehicleIdErrorMessage = vm.withExternalVehicle ? "Vous n'avez pas sélectionné le véhicule interne ou celui-ci a été supprimé. Vous pouvez aussi indiquer un véhicule externe en cochant la case à droite du champ véhicule interne" : "Vous n'avez pas sélectionné le véhicule interne ou celui-ci a été supprimé.";

                  Notiflix.Notify.failure(vehicleIdErrorMessage);
                  vm.currentTab = "Généralités";
                  save = false;
                }
              }

              if (!vm.model.vehicleType && explicitValues.includes(vm.model.typeOfAccident)) {
                Notiflix.Notify.failure("Vous n'avez pas indiqué le type de véhicule");
                vm.currentTab = "Généralités";
                save = false;
              }

              if (!vm.model.driverId || vm.model.driverId.length < 24) {
                Notiflix.Notify.failure("Vous n'avez pas sélectionné le collaborateur ou celui-ci a été supprimé.");
                vm.currentTab = "Généralités";
                save = false;
              }

              if (!vm.model.groupId && !vm.model._id) {
                // Mandatory only if creation
                Notiflix.Notify.failure("Vous n'avez pas indiqué le groupe associé");
                vm.currentTab = "Généralités";
                save = false;
              }

              if (explicitValues.includes(vm.model.typeOfAccident) && (vm.customer.decosiRepairer === "mandatory" || vm.customer.severityDamageIsMandatory === true)) {
                if (!vm.model.severityDamage) {
                  Notiflix.Notify.failure("Vous n'avez pas indiqué la gravité des dommages");
                  vm.currentTab = "Généralités";
                  save = false;
                } else if (["nonRolling", "wreck"].includes(vm.model.severityDamage) && (!vm.model.repairerInfo || !vm.model.repairerAddress)) {
                  Notiflix.Notify.failure("Vous n'avez pas indiqué le réparateur (nom et adresse)");
                  vm.currentTab = "Généralités";
                  save = false;
                }
              }

              if (!(vm.customer.refDamageNotEditable !== true && vm.model.name && vm.model.name.length > 0 && vm.model.name != vm.previousName)) {
                _context8.next = 23;
                break;
              }

              _context8.next = 21;
              return DamagesService.count({
                name: vm.model.name,
                customerId: vm.model.customerId
              });

            case 21:
              value = _context8.sent;

              if (value >= 1) {
                Notiflix.Notify.failure("Cette référence est déjà associée à un autre sinistre");
                vm.currentTab = "Généralités";
                save = false;
              } else if (value == 0) {
                console.log("name checked !");
              } else {
                Notiflix.Notify.failure("Erreur plateforme : rééssayer ou contacter le support");
                save = false;
              }

            case 23:

              if (vm.withExternalVehicle) {
                if (vm.model.externalVehicle) {
                  vm.model.vehicleId = null;
                } else {
                  vm.model.externalVehicleName = "";
                  vm.model.externalVehicleCompany = "";
                  vm.model.externalVehicleCompanyType = "";
                }
              }

              if (vm.model.insurerRefInsurer) {
                // can not be deleted
                if (vm.model.insurer) {
                  vm.model.insurer.refInsurer = vm.model.insurerRefInsurer;
                }
                delete vm.model.insurerRefInsurer;
              }

              if (!(vm.model.costProvision > 0 && vm.model.typeDamageStatus === "close" && vm.previousStatus !== "close" && save)) {
                _context8.next = 30;
                break;
              }

              _context8.next = 28;
              return swal({
                title: "Attention",
                text: "Vous vous appr\xEAtez \xE0 cl\xF4turer ce dossier, voulez-vous effacer le montant de la provision ?",
                icon: "warning",
                dangerMode: true,
                buttons: {
                  cancel: "Non",
                  confirm: "Oui"
                }
              });

            case 28:
              responseToCheck = _context8.sent;


              if (responseToCheck) {
                vm.model.costProvision = 0;
              }

            case 30:
              if (!save) {
                _context8.next = 55;
                break;
              }

              if (!(!vm.model._id && (!vm.model.docs || vm.model.docs.length === 0 || !vm.model.docs.map(function (d) {
                return d.what.value;
              }).includes("DO3")))) {
                _context8.next = 37;
                break;
              }

              _context8.next = 34;
              return swal({
                title: "Attention",
                text: "Aucun " + (vm.model.typeOfAccident === "theft" ? "dépôt de plainte/constat amiable" : "constat amiable") + " n'a \xE9t\xE9 ajout\xE9. Confirmez-vous que vous n'avez pas de " + (vm.model.typeOfAccident === "theft" ? "dépôt de plainte/constat amiable" : "constat amiable") + " \xE0 transmettre pour cette d\xE9claration ?",
                icon: "warning",
                dangerMode: true,
                buttons: {
                  cancel: "Annuler",
                  confirm: "Confirmer"
                }
              });

            case 34:
              _responseToCheck = _context8.sent;

              if (_responseToCheck) {
                _context8.next = 37;
                break;
              }

              return _context8.abrupt("return");

            case 37:

              delete vm.model.groupIdIsAutoFilled; // To avoid saving this field (uses only for hideExpression)

              // Remove all calculated fields

              // Pas de calcul automatique si V1/V2
              delete vm.model.sharedLalCost;
              delete vm.model.costContext;
              delete vm.model.costTotalLal;
              delete vm.model.newCostTotal;
              delete vm.model.newCostCompagny;
              delete vm.model.newCostInsurer;

              delete vm.model.lalCostDeductible;
              delete vm.model.withCostDeductibleFromLal;

              if (!vm.model.withInjury) {
                vm.model.typeOfInjury = null;
              }

              if (!vm.model.withThirdParty) {
                vm.model.thirdPartyDriverName = null;
                vm.model.thirdPartyCompagnyName = null;
                vm.model.thirdPartyAssurerName = null;
              }

              if (!vm.model.insurer) {
                vm.model.insurer = {};
              }
              if (vm.model.insurerNoReport === true) {
                vm.model.insurer.noReport = true;
              } else {
                vm.model.insurer.noReport = false;
              }
              delete vm.model.insurerNoReport;

              delete vm.model.isRestricted;

              delete vm.model.repairers;

              console.log("save damage :", vm.model);

              vm.save();

            case 55:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    vm.ready = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
              _context9.prev = 1;
              _context9.next = 4;
              return vm.createFields();

            case 4:
              _context9.next = 9;
              break;

            case 6:
              _context9.prev = 6;
              _context9.t0 = _context9["catch"](1);

              console.error(_context9.t0);

            case 9:

              if (!vm.model._id && vm.customer.assignGroupAfterDamageCreation === "driver") {
                // set to true if driver is not selected at the beginning
                vm.model.groupIdIsAutoFilled = true;
              }

              Notiflix.Loading.remove();

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this, [[1, 6]]);
    }));

    $controller("CreateBaseController", {
      vm: vm,
      $scope: $scope,
      service: DamagesService,
      listPage: "damages",
      nameModel: "un sinistre",
      params: params
    });
  }
})();